import React from "react";

const GoogleMap = () => {
  return (
    // <div style={{ width: "100%",  position: "relative" }}>
      <iframe
        title="MSSAT Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.1079935057887!2d91.8860339119493!3d25.56807362738006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x37507f00476a8dc1%3A0x34429851bed7116b!2sMSSAT!5e0!3m2!1sen!2sin!4v1747910570258!5m2!1sen!2sin" 
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        aria-hidden="false"
         loading="lazy"
         referrerPolicy="no-referrer-when-downgrade">
      </iframe>
    // </div>
  );
};

export default GoogleMap;
